/**
 * Transaction
 * An account of what has happened.
 */

'use strict';

exports.__esModule = true;
exports['default'] = Transaction;

function Transaction(type, payload, complete) {
  if (process.env.NODE_ENV !== 'production' && !type) {
    throw new TypeError('Transaction was created with the invalid type: ' + type);
  }

  return {
    type: '' + type,
    error: false,
    active: arguments.length > 1,
    payload: payload,
    complete: complete
  };
}

module.exports = exports['default'];
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbInNyYy9UcmFuc2FjdGlvbi5qcyJdLCJuYW1lcyI6W10sIm1hcHBpbmdzIjoiOzs7Ozs7OztxQkFLd0IsV0FBVzs7QUFBcEIsU0FBUyxXQUFXLENBQUUsSUFBSSxFQUFFLE9BQU8sRUFBRSxRQUFRLEVBQUU7QUFDNUQsTUFBSSxPQUFPLENBQUMsR0FBRyxDQUFDLFFBQVEsS0FBSyxZQUFZLElBQUksQ0FBQyxJQUFJLEVBQUU7QUFDbEQsVUFBTSxJQUFJLFNBQVMsQ0FBQyxpREFBaUQsR0FBRyxJQUFJLENBQUMsQ0FBQTtHQUM5RTs7QUFFRCxTQUFPO0FBQ0wsUUFBSSxPQUFXLElBQUksQUFBRztBQUN0QixTQUFLLEVBQU0sS0FBSztBQUNoQixVQUFNLEVBQUssU0FBUyxDQUFDLE1BQU0sR0FBRyxDQUFDO0FBQy9CLFdBQU8sRUFBSSxPQUFPO0FBQ2xCLFlBQVEsRUFBRyxRQUFRO0dBQ3BCLENBQUE7Q0FDRiIsImZpbGUiOiJzcmMvVHJhbnNhY3Rpb24uanMiLCJzb3VyY2VzQ29udGVudCI6WyIvKipcbiAqIFRyYW5zYWN0aW9uXG4gKiBBbiBhY2NvdW50IG9mIHdoYXQgaGFzIGhhcHBlbmVkLlxuICovXG5cbmV4cG9ydCBkZWZhdWx0IGZ1bmN0aW9uIFRyYW5zYWN0aW9uICh0eXBlLCBwYXlsb2FkLCBjb21wbGV0ZSkge1xuICBpZiAocHJvY2Vzcy5lbnYuTk9ERV9FTlYgIT09ICdwcm9kdWN0aW9uJyAmJiAhdHlwZSkge1xuICAgIHRocm93IG5ldyBUeXBlRXJyb3IoJ1RyYW5zYWN0aW9uIHdhcyBjcmVhdGVkIHdpdGggdGhlIGludmFsaWQgdHlwZTogJyArIHR5cGUpXG4gIH1cblxuICByZXR1cm4ge1xuICAgIHR5cGUgICAgIDogYCR7IHR5cGUgfWAsXG4gICAgZXJyb3IgICAgOiBmYWxzZSxcbiAgICBhY3RpdmUgICA6IGFyZ3VtZW50cy5sZW5ndGggPiAxLFxuICAgIHBheWxvYWQgIDogcGF5bG9hZCxcbiAgICBjb21wbGV0ZSA6IGNvbXBsZXRlXG4gIH1cbn1cbiJdfQ==




/*****************
 ** WEBPACK FOOTER
 ** ./~/microcosm/Transaction.js
 ** module id = 192
 ** module chunks = 0
 **/